// Compile picker state back to the five-field expression the API stores.
// `unknown` returns its original text verbatim: we could not describe it, so we
// have no business rewriting it either.
export function partsToCron(parts) {
  const { repeat, minute = 0, hour = 9 } = parts ?? {}

  if (repeat === 'unknown') return String(parts?.raw ?? '')
  if (repeat === 'custom') {
    const every = Math.max(1, Number(parts.every) || 1)
    return parts.unit === 'hours' ? `${minute} */${every} * * *` : `*/${every} * * * *`
  }
  if (repeat === 'hourly') return `${minute} * * * *`
  if (repeat === 'weekdays') return `${minute} ${hour} * * 1-5`
  if (repeat === 'weekly') {
    const days = parts.weekdays?.length ? [...parts.weekdays].sort() : [1]
    return `${minute} ${hour} * * ${days.join(',')}`
  }
  if (repeat === 'monthly') {
    // Not clamped to 28: a stored `0 9 31 * *` must come back out as day 31, even
    // though cron simply skips the months that have no 31st.
    return `${minute} ${hour} ${Math.min(31, Math.max(1, parts.dayOfMonth || 1))} * *`
  }
  return `${minute} ${hour} * * *`
}
